import { render, staticRenderFns } from "./ProductProperty.vue?vue&type=template&id=7d41a994&scoped=true&lang=pug"
import script from "./ProductProperty.vue?vue&type=script&lang=js"
export * from "./ProductProperty.vue?vue&type=script&lang=js"
import style0 from "./ProductProperty.vue?vue&type=style&index=0&id=7d41a994&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d41a994",
  null
  
)

export default component.exports